import{jsx as i}from"react/jsx-runtime";import{twMerge as e}from"tailwind-merge";
/**
 * 콘텐츠 사이에 시각적 구분선을 생성하는 컴포넌트
 * @param {Object} props
 * @param {boolean} [props.isVertical=false] - true일 경우 세로 구분선, false일 경우 가로 구분선
 * @param {boolean} [props.isSub=false] - true일 경우 연한 회색, false일 경우 진한 회색 사용
 * @param {string} [props.className] - 추가적인 CSS 클래스
 * @returns {JSX.Element} 구분선 요소
 * @example
 * // 가로 구분선
 * <Divider />
 *
 * // 세로 구분선
 * <Divider isVertical />
 *
 * // 연한 회색의 구분선
 * <Divider isSub />
 *
 */const r=({isVertical:r=!1,isSub:s=!1,className:t})=>/*#__PURE__*/i("div",{"data-testid":"design-system-divider",className:e("flex-shrink-0",r?"h-full w-px":"h-px w-full",s?"bg-w-gray-100":"bg-w-gray-200",t)});export{r as Divider};
